import { FEATURE } from '~/common/enums/feature.enum';
// todo: move to the common domain
import GamecenterDetailPage from '~/domains/contest/domains/gamecenter/pages/detail';
import SplitClient from '~/domains/contest/domains/manage/domains/common/split/SplitClient';
import { getContest } from '~/services/contests/contests.service.api';

export async function getServerSideProps({ params }: { params: { contestUuid: string } }) {
  const { contestUuid } = params;
  const fullContest = await getContest(contestUuid);

  const isDynamicContestLinkPreviewEnabled = await SplitClient.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW
  );
  const isDynamicContestLinkPreviewBase64Enabled = await SplitClient.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_BASE64
  );
  const isDynamicContestLinkPreviewDeadlineEnabled = await SplitClient.getTreatment(
    'anonymous',
    FEATURE.ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_DEADLINE
  );

  if (!fullContest) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      fullContest,
      contestUuid,
      isDynamicContestLinkPreviewEnabled: isDynamicContestLinkPreviewEnabled === 'on',
      isDynamicContestLinkPreviewBase64Enabled: isDynamicContestLinkPreviewBase64Enabled === 'on',
      isDynamicContestLinkPreviewDeadlineEnabled:
        isDynamicContestLinkPreviewDeadlineEnabled === 'on',
    },
  };
}

function DetailPage() {
  return <GamecenterDetailPage />;
}

export default DetailPage;

DetailPage.isPublic = true;
DetailPage.hasOwnAppshell = true;
